// Diagnose Mode: VDR multi-session (Mode 3) only.
import { Injectable, signal } from '@angular/core';

/**
 * Sticky store for the internal Mode 3 project id extracted from `/pid/:projectId` on landing.
 * The signal is set when the Mode 3 project component activates and stays populated for the rest
 * of the tab's lifetime so the interceptor can keep appending `projectId` to every outgoing
 * request — including calls issued after the user has navigated into a per-session route
 * (`/sid/:sessionId`) where the projectId is no longer present in the URL.
 */
@Injectable({ providedIn: 'root' })
export class Mode3ContextService {
  readonly projectId = signal<string | null>(null);
  readonly referenceId = signal<string | null>(null);

  setProjectId(id: string | null): void {
    this.projectId.set(id && id.length ? id : null);
  }

  setReferenceId(id: string | null): void {
    this.referenceId.set(id && id.length ? id : null);
  }

  clear(): void {
    this.projectId.set(null);
    this.referenceId.set(null);
  }
}
